<router-outlet name="action"></router-outlet>
<mat-sidenav-container
  class="navigation-container"
  [class.business-center-client__navigation__drawer-open]="sidePanel.opened === true"
  (backdropClick)="closeSideNav()"
>
  <mat-sidenav-content
    class="main-content"
    [ngClass]="{
      'brand-view': isCurrentLocationABrand$ | async,
    }"
    [ngStyle]="{ 'margin-right': toolbarRightDistance }"
  >
    @if ((hideNavToolbar$ | async) !== true) {
      <mat-toolbar app-toolbar class="bc-app-toolbar" [ngStyle]="{ right: toolbarRightDistance, top: topGap + 'px' }">
        @if (breadcrumbs()?.length > 1) {
          <va-breadcrumbs [breadcrumbs]="breadcrumbs()"></va-breadcrumbs>
        }
        @if (breadcrumbs()?.length === 1) {
          <h1 id="breadcrumb-header" class="breadcrumb-header">{{ breadcrumbs()[0]?.text | translate }}</h1>
        }
        <ng-template [cdkPortalOutlet]="breadcrumbPortalContent()"></ng-template>
        <app-launch-app-button></app-launch-app-button>
        @if (isWorkOrderDetailsVisible$ | async) {
          @if (workOrderBadgeTemplate$ | async; as workOrderBadgeTemplate) {
            <ng-container [ngTemplateOutlet]="workOrderBadgeTemplate"></ng-container>
          }
        }
        <span class="fill-space"></span>
        <ng-template #login_button>
          <a mat-button href="/login/?nextUrl={{ router.url }}">
            {{ 'NAVIGATION.MENU.LOGIN' | translate }}
          </a>
        </ng-template>
        <!-- Display print button in toolbar -->
        @if ((displayPrintButton$ | async) === true) {
          <button class="print-button" mat-icon-button color="primary" (click)="print()">
            <mat-icon aria-label="Print Executive Report">local_printshop</mat-icon>
          </button>
        }
        @if ((isCurrentLocationABrand$ | async) === false) {
          <ng-template [cdkPortalOutlet]="pageActionsPortalContent()"></ng-template>
        }
        @for (button of actionButtons$ | async; track button) {
          <app-nav-action-button [config]="button"></app-nav-action-button>
        }
        @if (showMyListingEditButton) {
          <button mat-raised-button color="primary" class="primary-action">
            {{ 'COMMON.ACTION_LABELS.EDIT' | translate }}
            <mat-icon>open_in_new</mat-icon>
          </button>
        }
        <!-- Compose a post button in Navigation -->
        @if (displayComposeButton$ | async) {
          <a
            mat-raised-button
            color="primary"
            class="compose-button"
            [routerLink]="[{ outlets: { action: ['compose-social-post'] } }]"
            queryParamsHandling="merge"
          >
            {{ 'BRANDS.COMPOSE_A_POST' | translate }}
          </a>
        }
        @if (displayDateSelector$ | async) {
          <bc-time-range-picker></bc-time-range-picker>
        }
        @if (displayFilterContainer$ | async) {
          <bc-brand-filter-container></bc-brand-filter-container>
        }
        @if (displayFilterToggle$ | async) {
          <button class="nav-btn" mat-stroked-button (click)="toggleFilter()">
            <mat-icon>tune</mat-icon>
            <span class="message">
              {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.PAGE_FILTERS' | translate }}
            </span>
          </button>
        }
      </mat-toolbar>
    }

    <div
      [ngClass]="{
        'subtract-toolbar': navigationService.subtractToolbarOffset$ | async,
        fullscreen: navigationService.displayFullScreen$ | async,
        'banner-padding': bannerAuthIsEnabled,
      }"
      class="content"
    >
      <router-outlet></router-outlet>
    </div>
    @if (bannerAuthIsEnabled) {
      <div class="banner-auth">
        <p>Welcome to {{ 'APP_NAME' | translate }}. Sign in to access all features.</p>
        <div class="banner-auth__actions">
          <button mat-flat-button color="primary" (click)="goToLogin()">
            {{ 'AUTH_WALL_MODAL.LOGIN.LOG_IN' | translate }}
          </button>
          @if (bannerAuthSignupIsEnabled$ | async) {
            <button mat-button color="primary" (click)="goToSignUp()">
              {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.SIGN_UP' | translate }}
            </button>
          }
        </div>
      </div>
    }
  </mat-sidenav-content>
  <mat-sidenav
    #sidePanel
    class="sidepanel"
    [ngClass]="[sidePanelSize, sidePanelMode ? sidePanelMode : '', 'atlas-gap']"
    [mode]="sidePanelMode"
    position="end"
    [opened]="sidePanelOpened"
    [fixedInViewport]="true"
    [disableClose]="true"
  >
    <div class="drawer-container">
      <!--
      When opening a drawer, Angular Material will focus on the first targetable element.
      This will cause buttons to be in a pressed state, and links to be highlighted. This is for accessibility.
      In order to allow the target to start in the side panel we add this anchor tag so it will be the first
      element highlighted. If the user hits "tab" it will continue to the next element in the drawer like normal.
      javascript:; makes it so the link does nothing if you hit "enter" href="#" would refresh the page.
      -->
      <div style="top: -1000px; position: absolute">
        <a href="javascript:;"></a>
      </div>
      <ng-template #inject></ng-template>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
